/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var ColumnFilterCondition = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnFilterCondition, _super);
    function ColumnFilterCondition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnFilterCondition.prototype.b = function () {
        return false;
    };
    ColumnFilterCondition.prototype.a = function (a, b) {
        return null;
    };
    ColumnFilterCondition.$t = markType(ColumnFilterCondition, 'ColumnFilterCondition');
    return ColumnFilterCondition;
}(Base));
export { ColumnFilterCondition };
//# sourceMappingURL=ColumnFilterCondition.js.map
